import React, { Component } from "react";

export default class Footer extends Component {
  render() {
    return (
      <div
        className="kt-footer kt-grid__item kt-grid kt-grid--desktop kt-grid--ver-desktop"
        id="kt_footer"
      >
        <div className="kt-footer__copyright">
          2026&nbsp;&copy;&nbsp;
          <a href="http://qucodes.com/" target="_blank" className="kt-link">
            Qucodes X Allugra
          </a>
        </div>

      </div>
    );
  }
}
